import { render, staticRenderFns } from "./ViewProducts.vue?vue&type=template&id=3e0592bb&scoped=true"
import script from "./ViewProducts.vue?vue&type=script&lang=js"
export * from "./ViewProducts.vue?vue&type=script&lang=js"
import style0 from "./ViewProducts.vue?vue&type=style&index=0&id=3e0592bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0592bb",
  null
  
)

export default component.exports